import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import {
  DonutChartEmpty,
  DonutChartProperty,
} from "../../../components/chart/DonutChartMain";
import {
  SumDebtInvestValue,
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import {
  ICON_BUILDING,
  ICON_CONTRACT,
  ICON_HOUSE,
  ICON_NAVIGATE_BALANCE,
} from "../../../utils/useIcons";
import {
  STYLE_BORDER_YELLOW_PROPOTION,
  STYLE_CARD_PROPOTION,
  STYLE_HEADER_SECTION_PROPOTION,
  STYLE_TITLE_PROPOTION,
} from "../../../utils/useStyle";
import { BoxWhite } from "../styles/Card";
import {
  sumCapitalInvest,
  sumDebtInvest,
  sumPersonalAsset,
} from "../../../functions/Balance/sumProperty";

const ViewPropertyProportion = ({ formBL, onClick, addInvest, addPrivate }) => {
  const setBalanceData = useBalanceStore((state) => state.setBalanceData);

  const balanceData = useBalanceStore((state) => state.balanceData);

  const [tempBalance, setTempBalance] = useState(balanceData);
  const [ReturnInsurance, setReturnInsurance] = useState([]);

  useEffect(() => {
    if (tempBalance) {
      let tempInsuranceReturn = tempBalance?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        tempBalance?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = tempBalance?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = tempBalance?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
    //==============================================//
  }, [balanceData]);

  const tempSumPropertyInvest = useMemo(() => {
    if (balanceData?.expenses_fixed_list) {
      return balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item?.expenses_insuarant_lifes)
        ?.flat()
        ?.reduce(
          (a, b) => a + Number(b?.more_details?.policy_surrender_value || 0),
          0
        );
    }
    return 0;
  }, [balanceData]);

  return (
    <div>
      <div className={STYLE_CARD_PROPOTION}>
        <div className={`${STYLE_HEADER_SECTION_PROPOTION} `}>
          <div className="">
            <div className={STYLE_TITLE_PROPOTION}>สัดส่วนสินทรัพย์</div>
            <div className={STYLE_BORDER_YELLOW_PROPOTION}></div>
          </div>
          <ICON_NAVIGATE_BALANCE onClick={onClick} />
        </div>

        {Number(balanceData?.sum_property_asset || 0) +
          SumDebtPersonalValue(balanceData) +
          sumCapitalInvest(addInvest, ReturnInsurance) +
          sumDebtInvest(balanceData) +
          sumPersonalAsset(addPrivate) +
          SumOtherDebtAmount(balanceData) +
          Number(balanceData?.sum_property_intangible || 0) <=
          0 ||
        isNaN(
          Number(balanceData?.sum_property_asset || 0) +
            SumDebtPersonalValue(balanceData) +
            sumCapitalInvest(addInvest, ReturnInsurance) +
            sumDebtInvest(balanceData) +
            sumPersonalAsset(addPrivate) +
            SumOtherDebtAmount(balanceData) +
            Number(balanceData?.sum_property_intangible || 0)
        ) ? (
          <DonutChartEmpty text={`สินทรัพย์`} />
        ) : (
          <DonutChartProperty
            text={`สินทรัพย์`}
            value={numeral(
              Number(balanceData?.sum_property_asset || 0) +
                SumDebtPersonalValue(balanceData) +
                sumCapitalInvest(addInvest, ReturnInsurance) +
                sumDebtInvest(balanceData) +
                sumPersonalAsset(addPrivate) +
                SumOtherDebtAmount(balanceData) +
                Number(balanceData?.sum_property_intangible || 0)
            ).format("0,0")}
            data1={balanceData?.sum_property_asset}
            data2={
              SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(addInvest, ReturnInsurance) +
              sumDebtInvest(balanceData)
            }
            data3={
              sumPersonalAsset(addPrivate) + SumOtherDebtAmount(balanceData)
            }
            data4={balanceData?.sum_property_intangible}
          />
        )}
        <BoxWhite
          title="สินทรัพย์สภาพคล่อง"
          icon="/images/proporty_asset2.png"
          colortext="text-purple700"
          value={balanceData?.sum_property_asset}
        />
        <BoxWhite
          title="สินทรัพย์เพื่อการลงทุน"
          icon={
            <ICON_BUILDING classNames=" w-8 h-8 fill-[#7f1eff] stroke-[#7f1eff] " />
          }
          colortext="text-[#7f1eff]"
          value={
            SumDebtPersonalValue(balanceData) +
            sumCapitalInvest(addInvest, ReturnInsurance) +
            sumDebtInvest(balanceData)
          }
          isIconTypeImage={false}
        />
        <BoxWhite
          title="สินทรัพย์ใช้ส่วนตัว"
          icon={
            <ICON_HOUSE classNames=" w-8 h-8 stroke-[#8c37fc] fill-none " />
          }
          colortext="text-[#8c37fc]"
          value={
            sumPersonalAsset(addPrivate) +
            Number(SumOtherDebtAmount(balanceData) || 0)
          }
          isIconTypeImage={false}
        />
        <BoxWhite
          title="สินทรัพย์ไม่มีตัวตน"
          icon={
            <ICON_CONTRACT classNames=" w-8 h-8 fill-[#8D32E8] stroke-[#8D32E8] " />
          }
          colortext="text-purple600"
          value={balanceData?.sum_property_intangible}
          isIconTypeImage={false}
        />
      </div>
    </div>
  );
};

export default ViewPropertyProportion;
